<template>
  <div>
    <wrapper>
      <div class="loading_container" v-if="loading">
        <pre-loader></pre-loader>
      </div>
      <fragment v-else>
        <div class="row">
          <div class="col m6">
            <lecture-display></lecture-display>
            <div class="row">
              <div class="col s2">
                <p style="font-size:16px;">
                  <b>Chapter</b>
                </p>
              </div>
              <div class="col s10 row_display">
                <p
                  @click="linkClick(item.chapter_id)"
                  v-for="item in chapters"
                  v-bind:key="item.chapter_id"
                >{{ item.chapter_id }}</p>
              </div>
            </div>
          </div>
          <div class="col m4 s12 offset-m1">
            <home-work :data="data.homeworks"></home-work>
            <div class="row exer_box">
              <h6>Exercise List</h6>
              <router-link :to="'/exercises/'+$route.params.id+'/'+$route.params.class_id">
                <p>Click Here</p>
              </router-link>
            </div>
            <div class="row exam_box" v-if="coming_exam">
              <h6>
                <b>* Coming Exam</b>
              </h6>
              <p>{{ coming_exam.date }}</p>
            </div>
          </div>
        </div>
      </fragment>
    </wrapper>
  </div>
</template>
<script>
import LectureDisplay from "@/components/Subject/LectureDisplay/LectureDisplay.vue";
import HomeWork from "@/components/HomeWork/HomeWork.vue";
export default {
  mounted() {
    this.$store.dispatch("get_subject", { id: this.$route.params.id });
  },
  components: {
    "lecture-display": LectureDisplay,
    "home-work": HomeWork
  },
  computed: {
    data() {
      return this.$store.getters.each_subject;
    },
    loading() {
      return this.$store.getters.class_loading;
    },
    chapters() {
      return this.$store.getters.chapters;
    },
    current_chapter() {
      return this.$store.getters.current_chapter;
    },
    coming_exam() {
      return this.$store.getters.coming_exam;
    }
  },
  methods: {
    linkClick(chapterID) {
      this.$store.dispatch("get_subject", {
        id: this.$route.params.id,
        chapter_id: chapterID
      });
    }
  }
};
</script>
<style lang="scss">
@import "@/style/colors.scss";
.class_description {
  margin-left: 20%;
  width: 60%;
  margin-top: 20px;
}

.description_box {
  position: absolute;
  bottom: 30px;
  right: 15%;
  left: 15%;
  width: 70%;
}

.row_display {
  display: flex;
  flex-direction: row;
  p {
    margin-left: 10px;
    font-size: 16px;
    background: $primaryColor;
    width: 50px;
    height: 30px;
    text-align: center;
    color: white !important;
  }
}

.exam_box {
  padding-left: 30px;
  padding-top: 50px;
  text-align: right;

  p {
    background: black;
    color: white;
    width: 150px;
    text-align: center;
    padding: 10px;
    font-size: 18px;
    float: right;
  }
}

.exer_box {
  padding-left: 30px;
  padding-top: 50px;
  text-align: left;

  h6 {
    font-weight: 500;
  }

  p {
    background: orange;
    color: black;
    width: 150px;
    text-align: center;
    padding: 10px;
    font-size: 18px;
    font-weight: 500;
  }
}
</style>